import { useState } from "react";
import { toast } from "react-hot-toast";
import { useDeleteQuizMutation } from "@features/quizzes/quizzesApi";
import QuizModal from "@admin/components/Modals/QuizModal";
import DeleteIcon from "@admin/components/SVG/DeleteIcon";
import EditIcon from "@admin/components/SVG/EditIcon";

const Quiz = ({ quiz }) => {
  const { id, question, video_title } = quiz || {};

  const [isModalOpen, setIsModalOpen] = useState(false);

  const openModal = () => {
    setIsModalOpen(true);
  };

  function closeModal() {
    setIsModalOpen(false);
  }

  const [deleteQuiz] = useDeleteQuizMutation(id);

  const handleDelete = async () => {
    const response = await deleteQuiz(id);
    if (response?.data) {
      toast.success("Quiz deleted successfully!");
    } else {
      toast.error("Quiz deleted failed!");
    }
  };

  const handleEdit = () => {
    openModal(id);
  };

  return (
    <tr>
      <td className="table-td">{question}</td>
      <td className="table-td">{video_title}</td>
      <td className="table-td flex gap-x-2 justify-center">
        <button onClick={handleDelete}>
          <DeleteIcon />
        </button>
        <button onClick={handleEdit}>
          <EditIcon />
        </button>
        <QuizModal quizId={id} open={isModalOpen} closeModal={closeModal} />
      </td>
    </tr>
  );
};

export default Quiz;
